<mat-dialog-content class="search-dialog-simple">
  <sc-super-search
    (search)="onSearch($event)"
    floatLabel="auto"
    styleClass="station-search-simple"
    (itemSelected)="selectItem($event)"
    (clear)="clearSearch()"></sc-super-search>
</mat-dialog-content>
